import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ptxhxzu9rh: FaireBrandEntity = {
  token: "b_ptxhxzu9rh",
  type: "brand",
  name: "Wholehearted Motherhood and Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/63a68d3fd2eafbf0015b2637f7c2d2ac829f77bfe7c954eaece433f88a1c0bb5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/30122213db4fb004540a7c6c263d6cee55e61339fe5cc517c647d1cdfb6a78da.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/63a68d3fd2eafbf0015b2637f7c2d2ac829f77bfe7c954eaece433f88a1c0bb5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30122213db4fb004540a7c6c263d6cee55e61339fe5cc517c647d1cdfb6a78da.jpeg",
  location: "Oronogo, MO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 150,
  isTopShop: true,
  isInsider: true,
  description:
    "I am Sarah, a wife to a hardworking husband and a busy stay at home mom of a one year old with twins on the way. God is good! We are a Christian family who loves all things outdoors. I design and make all your apparel from our home in the Midwest.\n \nI grew up around a family business and saw how it supported our family and always wanted something that we could make ours as a family. This business is built around all the things that we love, God, our kids, camping, outdoors, and so much more. \n \nWe offer a beautiful apparel collection that your customers will love! Our apparel ranges from beautiful tees, crewnecks, hoodies and even infant and toddler attire. SwearinStot prides themselves on top notch products and excellent customer service. \n \nI want to thank you for your order. When you order local you truly help put food on the table, kids in sports and all the things in life. If you have any questions or want something you do not see please do not hesitate to reach out. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.021Z",
    importedBy: "entity-db-cli",
  },
};
